module.exports = __webpack_public_path__ + "img/detail_bg.0afcf497.png";